/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Plus, Trash2, Upload, Save, ArrowLeft, Edit, Copy, ChevronDown, ChevronRight, Sparkles, X } from 'lucide-react';
import { API_URL } from '../../config';
import ImportBrandModal from '../settings/ImportBrandModal';
import SeoAiWizardModal from './SeoAiWizardModal';
import AiExpandModal from '../../components/AiExpandModal';
import * as XLSX from "xlsx";
import { useRef } from "react";


const ClientMediaManager = ({ projectId }) => {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newMedia, setNewMedia] = useState({ url: '', title: '', mediaName: '', notes: '' });
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (projectId) {
      fetchMedia();
    }
  }, [projectId]);


  
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      setLoading(true);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/import/${projectId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        alert(`成功导入 ${data.count} 条记录`);
        fetchMedia(); // refresh list
      } else {
        alert(data.error || '导入失败');
      }
    } catch (error) {
      alert('上传异常');
    } finally {
      setLoading(false);
      e.target.value = null; // reset
    }
  };

  const handleDownloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      ['文章URL(必填)', '文章标题(选填)', '媒体名称(必填)', '备注(选填)'],
      ['https://zhuanlan.zhihu.com/p/12345', '马牌轮胎评测', '知乎', '2026年Q1公关稿件']
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '自有媒体模板');
    XLSX.writeFile(wb, '自有媒体批量导入模板.xlsx');
  };

  const fetchMedia = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${projectId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setMediaList(data.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (!newMedia.url) return alert('请输入URL');
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${projectId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(newMedia)
      });
      const data = await res.json();
      if (data.success) {
        setMediaList([data.data, ...mediaList]);
        setNewMedia({ url: '', title: '', mediaName: '', notes: '' });
      } else {
        alert(data.error || '添加失败');
      }
    } catch (e) {
      alert('网络错误');
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('确定删除吗？')) return;
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setMediaList(mediaList.filter(m => m.id !== id));
      }
    } catch (e) {
      alert('删除失败');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 p-4 rounded-lg text-sm">
        <p className="font-semibold mb-1">什么是自有媒体矩阵 (SEO 防守盘)？</p>
        <p>在此处录入品牌官方网站、官方社交账号主页以及自发公关稿件的具体链接（URL）。系统在执行 SEO 抓取探测时，会自动比对这些链接是否出现在搜索结果前列，以此为您计算自有资产在搜索引擎中的“占位率”与“能见度”。</p>
      </div>

      
      <div className="bg-gray-50 dark:bg-slate-800 p-4 rounded-lg border border-gray-200 dark:border-slate-700">
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-sm font-medium text-gray-900 dark:text-slate-100">录入新链接</h4>
          <div className="flex gap-2">
            <button onClick={handleDownloadTemplate} className="text-xs text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300">
              下载 Excel 模板
            </button>
            <input 
              type="file" 
              ref={fileInputRef} 
              className="hidden" 
              accept=".xlsx, .xls" 
              onChange={handleImport}
            />
            <button onClick={() => fileInputRef.current?.click()} className="bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-600 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1 shadow-sm">
              <Upload className="w-3.5 h-3.5" /> 批量导入 Excel
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

          <div className="col-span-2">
            <input id="clientMediaUrl" type="text" placeholder="文章URL (必填)" value={newMedia.url} onChange={e => setNewMedia({...newMedia, url: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div>
            <input type="text" placeholder="媒体名称 (如: 知乎)" value={newMedia.mediaName} onChange={e => setNewMedia({...newMedia, mediaName: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div>
            <button onClick={handleAdd} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2">
              <Plus className="w-4 h-4" /> 添加记录
            </button>
          </div>
          <div className="col-span-2">
            <input type="text" placeholder="文章标题 (选填)" value={newMedia.title} onChange={e => setNewMedia({...newMedia, title: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div className="col-span-2">
            <input type="text" placeholder="备注 (选填)" value={newMedia.notes} onChange={e => setNewMedia({...newMedia, notes: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="text-xs text-gray-500 dark:text-slate-400 bg-gray-50 dark:bg-slate-800/50 uppercase">
            <tr>
              <th className="px-4 py-3 rounded-tl-lg">媒体名称</th>
              <th className="px-4 py-3">链接 & 标题</th>
              <th className="px-4 py-3">备注</th>
              <th className="px-4 py-3">录入时间</th>
              <th className="px-4 py-3 rounded-tr-lg w-20">操作</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" className="px-4 py-8 text-center text-gray-500">加载中...</td></tr>
            ) : mediaList.length === 0 ? (
              <tr><td colSpan="5" className="px-4 py-8 text-center text-gray-500 border-b border-gray-100 dark:border-slate-700">暂无自有媒体数据</td></tr>
            ) : (
              mediaList.map(item => (
                <tr key={item.id} className="border-b border-gray-100 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-800/50">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-slate-200">{item.mediaName || '-'}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-1">
                      {item.title && <span className="font-medium text-gray-800 dark:text-slate-300">{item.title}</span>}
                      <a href={item.url} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline break-all">{item.url}</a>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-gray-500 dark:text-slate-400">{item.notes || '-'}</td>
                  <td className="px-4 py-3 text-gray-500 dark:text-slate-400">{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td className="px-4 py-3">
                    <button onClick={() => handleDelete(item.id)} className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30 rounded">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};


function SeoConfig() {
  useEffect(() => {
    const fetchColleagues = async () => {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/colleagues`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (res.ok) setColleagues(await res.json());
      } catch (e) { console.error(e); }
    };
    fetchColleagues();
    // fetchProjects moved down

    const fetchUsersIfAdmin = async () => {
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      if (currentUser.role === 'ADMIN') {
        try {
          const token = localStorage.getItem('token') || '';
          const res = await fetch(`${API_URL}/admin/users`, { headers: { 'Authorization': `Bearer ${token}` } });
          if (res.ok) {
            const data = await res.json();
            setAllUsers(Array.isArray(data) ? data : (data.data || []));
          }
        } catch (e) { console.error(e); }
      }
    };
    fetchUsersIfAdmin();
    // fetchProjects will be called later if needed, but actually we can just fetch it inside
    const initialFetchProjects = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/brand-projects?system=seo`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
          setProjects(data.data);
          setLoading(false);
          return data.data;
        }
      } catch(e){ console.error(e); }
      setLoading(false);
    };
    initialFetchProjects().then((fetchedProjects) => {
      const gb = localStorage.getItem('globalBrand');
      if (gb && gb !== 'all' && fetchedProjects && fetchedProjects.length > 0) {
        const target = fetchedProjects.find(p => String(p.id) === String(gb));
        if (target) {
          handleEdit(target);
        }
      }
    });
  }, []);

  const [activeTab, setActiveTab] = useState('basic');
  const [view, setView] = useState('list');

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAiWizardOpen, setIsAiWizardOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [colleagues, setColleagues] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [systemPersonas, setSystemPersonas] = useState([]);
  const [showAllSystem, setShowAllSystem] = useState(false);
  const [showSocialMedia, setShowSocialMedia] = useState(false);
  const fileInputRef = useRef(null);

  
  const [aiExpandState, setAiExpandState] = useState({ isOpen: false, themeName: '', packageId: null, itemId: null });
  const [isGeneratingKeywords, setIsGeneratingKeywords] = useState(false);
const [editingId, setEditingId] = useState(null);
  const [brand, setBrand] = useState({ name: '', subBrandName: '', aliases: '', website: '', products: '', targetUserId: '' });
  const [collaborators, setCollaborators] = useState([]);
  const [competitors, setCompetitors] = useState([]);

  const [themes, setThemes] = useState([]);
  const [keywordCounts, setKeywordCounts] = useState({ total: 0, unassigned: 0 });
  const [selectedThemeId, setSelectedThemeId] = useState('all');
  const [keywordsList, setKeywordsList] = useState([]);
  const [selectedKeywordIds, setSelectedKeywordIds] = useState([]);
  const [isCategorizedExpanded, setIsCategorizedExpanded] = useState(true);
  const [isBulkEditing, setIsBulkEditing] = useState(false);
  const [bulkEditForm, setBulkEditForm] = useState({ keywordType: '', funnelStage: '', competitorId: '', themeId: '' });
  const [isKeywordsLoading, setIsKeywordsLoading] = useState(false);
  const [isAddingTheme, setIsAddingTheme] = useState(false);
  const [newThemeName, setNewThemeName] = useState('');
  const [isAddingKeyword, setIsAddingKeyword] = useState(false);
  const [isBulkAddingKeyword, setIsBulkAddingKeyword] = useState(false);
  const [bulkKeywordText, setBulkKeywordText] = useState('');
  const [competitorsList, setCompetitorsList] = useState([]);

  const [keywordMode, setKeywordMode] = useState('standard');
  const [keywords, setKeywords] = useState('');
  const [classifiedKeywords, setClassifiedKeywords] = useState('');
  const [keywordPackages, setKeywordPackages] = useState([]);
  const [alertConfig, setAlertConfig] = useState({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
  
  const [productMappingMode, setProductMappingMode] = useState('simple'); // 'simple' | 'matrix'
  const [productMappings, setProductMappings] = useState([]); // [{id, hostProduct, competitorProducts: [{compId, compName, prodName}]}]

  const addProductMapping = () => {
    setProductMappings([...productMappings, {
      id: Date.now(),
      hostProduct: '',
      competitorProducts: competitors.map(c => ({ compId: c.id, compName: c.name, prodName: '' }))
    }]);
  };

  const removeProductMapping = (id) => {
    setProductMappings(productMappings.filter(m => m.id !== id));
  };

  const updateProductMapping = (mappingId, field, value, compId = null) => {
    setProductMappings(productMappings.map(m => {
      if (m.id === mappingId) {
        if (compId) {
          const newCompProds = [...m.competitorProducts];
          const existingIdx = newCompProds.findIndex(cp => cp.compId === compId);
          if (existingIdx >= 0) {
            newCompProds[existingIdx][field] = value;
          } else {
            // Find comp name just in case
            const comp = competitors.find(c => c.id === compId);
            newCompProds.push({ compId, compName: (comp ? comp.name : '') || '', prodName: field === 'prodName' ? value : '', aliases: field === 'aliases' ? value : '' });
          }
          return { ...m, competitorProducts: newCompProds };
        } else {
          return { ...m, [field]: value };
        }
      }
      return m;
    }));
  };

  // Sync competitor additions/removals into product matrix
  useEffect(() => {
    if (productMappings.length > 0) {
      setProductMappings(prev => prev.map(m => {
        const newCompProds = competitors.map(c => {
          const existing = m.competitorProducts.find(cp => cp.compId === c.id);
          return existing || { compId: c.id, compName: c.name, prodName: '' };
        });
        return { ...m, competitorProducts: newCompProds };
      }));
    }
  }, [competitors]);

  const handleCreate = () => {
    setEditingId(null);
    setBrand({ name: '', subBrandName: '', logo: '', aliases: '', website: '', products: '', targetUserId: '', socialMedia: { weibo: '', douyin: '', xhs: '', wechat: '' }, themes: [{id: 'default_theme_1', name: '', keywords: ''}], personas: [] });
    setCompetitors([]);
    setKeywordMode('standard');
    setKeywords('');
    setClassifiedKeywords('');
    setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
    setKeywordPackages([{ id: 'default_pkg_1', name: '默认词包', items: [{ id: 'default_pkg_item_1', core: '', expansions: '' }] }]);
    setProductMappingMode('simple');
    setProductMappings([]);
    setActiveTab('basic');
    setView('edit');
  };

  const handleEdit = (project) => {
    setEditingId(project.id);
    setBrand({ 
      targetUserId: project.userId || '',
      name: project.name, 
      subBrandName: project.subBrandName || '', 
      logo: project.logo || '',
      aliases: project.aliases || '', 
      website: project.website || '', 
      products: project.products || '',
      socialMedia: project.socialMedia || { weibo: '', douyin: '', xhs: '', wechat: '' },
      themes: project.themes && project.themes.length > 0 ? project.themes : [{id: 'default_theme_1', name: '', keywords: ''}],
      personas: project.personas || []
    });
    setCollaborators(project.collaborators ? project.collaborators.map(c => c.userId) : []);
    setCompetitors(project.competitors || []);
    setKeywordMode(project.keywordMode || 'standard');
    setKeywords(project.keywords || '');
    setClassifiedKeywords(project.classifiedKeywords || '');
    if (project.alertConfig) {
      try {
        setAlertConfig(JSON.parse(project.alertConfig));
      } catch (e) {
        setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
      }
    } else {
      setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
    }
    let loadedPkgs = project.keywordPackages && project.keywordPackages.length > 0 ? project.keywordPackages : [{ id: 'default_pkg_1', name: '默认词包', items: [{ id: 'default_pkg_item_1', core: '', expansions: '' }] }];
    loadedPkgs = loadedPkgs.map(pkg => ({
      ...pkg,
      items: pkg.items && pkg.items.length > 0 ? pkg.items : [{ id: `empty_${Date.now()}_${Math.random()}`, core: '', expansions: '' }]
    }));
    setKeywordPackages(loadedPkgs);
    
    // Convert old comma-separated products to mapping structure if needed
    let initMappings = [];
    if (project.productMappings && project.productMappings.length > 0) {
      initMappings = project.productMappings.map(m => ({
        id: m.id,
        hostProduct: m.hostProduct,
        hostAliases: m.hostAliases || '',
        competitorProducts: (project.competitors || []).map(c => {
          const dbCp = m.competitorProducts ? m.competitorProducts.find(cp => cp.competitorId === c.id) : null;
          return {
            compId: c.id,
            compName: c.name,
            prodName: dbCp ? dbCp.prodName : '',
            prodAliases: dbCp ? dbCp.prodAliases : ''
          };
        })
      }));
    } else if (project.products) {
      initMappings = project.products.split(/\n+/).map(p => p.trim()).filter(Boolean).map(p => ({
        id: Date.now() + Math.random(),
        hostProduct: p,
        competitorProducts: project.competitors ? project.competitors.map(c => ({ compId: c.id, compName: c.name, prodName: '' })) : []
      }));
    }
    setProductMappings(initMappings);
    setProductMappingMode(project.productMappingMode || 'simple');
    setActiveTab('basic');
    setView('edit');
  };

  const handleUploadImage = async (e, isCompetitor, compId = null) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch('/api/images/upload', {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      
      if (data.url) {
        if (!isCompetitor) {
          setBrand({...brand, logo: data.url});
        } else {
          updateCompetitor(compId, 'logo', data.url);
        }
      } else {
        alert('上传失败');
      }
    } catch (error) { console.error('上传图片失败', error); alert('上传图片报错'); }
  };

  
  
  
  const fetchProjects = async () => {
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/brand-projects?system=seo`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setProjects(data.data);
        return data.data;
      }
    } catch (e) {
      console.error('Failed to fetch projects', e);
    }
    return null;
  };

  const handleGenerateKeywordsFromThemes = async () => {
    // legacy function removed
  };

  const handleAiExpandConfirm = async (selectedWords) => {
    if (!editingId) {
      alert("⚠️ 请先点击右上角「保存配置」完成项目创建，然后再使用智能拓词！");
      return;
    }
    // Add words to currently selected theme/package
    try {
      const res = await fetch(`${API_URL}/seo/config/keywords/batch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          brandProjectId: editingId,
          themeId: aiExpandState.packageId,
          keywords: selectedWords
        })
      });
      if (res.ok) {
        setAiExpandState({ isOpen: false, themeName: '', packageId: null, itemId: null });
        fetchKeywordsList();
        fetchBaseData();
      }
    } catch(e) { console.error(e); }
  };

  const fetchBaseData = async () => {
    if (!editingId) return;
    try {
      const compRes = await fetch(`${API_URL}/brand-projects/${editingId}/competitors`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (compRes.ok) setCompetitorsList(await compRes.json());
      
      const themesRes = await fetch(`${API_URL}/seo/config/themes/${editingId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (themesRes.ok) setThemes(await themesRes.json());
      
      const countsRes = await fetch(`${API_URL}/seo/config/keyword-counts/${editingId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (countsRes.ok) setKeywordCounts(await countsRes.json());
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (activeTab === 'keywords') {
      fetchBaseData();
    }
  }, [activeTab, editingId]);

  const fetchKeywordsList = async () => {
    if (!editingId) return;
    setIsKeywordsLoading(true);
    try {
      let url = `${API_URL}/seo/config/keywords/${editingId}`;
      if (selectedThemeId !== 'all') {
        url += `?themeId=${selectedThemeId}`;
      }
      const res = await fetch(url, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (res.ok) {
        const data = await res.json();
        setKeywordsList(data);
        setSelectedKeywordIds([]);
        // Also refresh counts to keep sidebar in sync
        fetchBaseData();
      }
    } catch(e) {
      console.error(e);
    } finally {
      setIsKeywordsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'keywords') {
      fetchKeywordsList();
    }
  }, [activeTab, selectedThemeId, editingId]);

  const handleUpdateKeyword = async (id, field, value) => {
    setKeywordsList(prev => prev.map(k => k.id === id ? { ...k, [field]: value } : k));
    try {
      const res = await fetch(`${API_URL}/seo/config/keywords/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ [field]: value })
      });
      if (res.ok && field === 'themeId') {
        fetchBaseData();
      }
    } catch(e) {
      console.error(e);
    }
  };

  const handleDeleteKeyword = async (id) => {
    // Optimistic delete from UI
    setKeywordsList(prev => prev.filter(k => k.id !== id));
    try {
      await fetch(`${API_URL}/seo/config/keywords/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      // We don't necessarily need to fetchKeywordsList if we removed it optimistically, but let's just do it
      fetchKeywordsList();
        fetchBaseData();
    } catch(e) { console.error(e); }
  };

  const handleToggleKeyword = (id) => {
    setSelectedKeywordIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  
  const handleToggleAllKeywords = (e) => {
    if (e.target.checked) setSelectedKeywordIds(keywordsList.map(k => k.id));
    else setSelectedKeywordIds([]);
  };

  const handleAddTheme = () => setIsAddingTheme(true);
  const handleAddKeyword = async () => {
    try {
      const res = await fetch(`${API_URL}/seo/config/keywords`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          brandProjectId: editingId,
          themeId: selectedThemeId === 'all' || selectedThemeId === 'unassigned' ? null : selectedThemeId,
          keyword: '',
          keywordType: 'category',
          funnelStage: 'Sense'
        })
      });
      if (res.ok) {
        fetchKeywordsList();
        fetchBaseData();
      }
    } catch(e) { console.error(e); }
  };

  const handleCreateTheme = async (name) => {
    if (!name.trim()) {
      setIsAddingTheme(false);
      setNewThemeName('');
      return;
    }
    if (!editingId) {
      alert("⚠️ 请先点击右上角「保存配置」完成项目创建，然后再新建词包！");
      setIsAddingTheme(false);
      return;
    }
    try {
      await fetch(`${API_URL}/seo/config/themes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ brandProjectId: editingId, name })
      });
      setIsAddingTheme(false);
      setNewThemeName('');
      fetchBaseData();
    } catch(e) { console.error(e); }
  };

  const handleUpdateTheme = async (id, newName) => {
    try {
      await fetch(`${API_URL}/seo/config/themes/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ name: newName })
      });
      fetchBaseData();
    } catch(e) { console.error(e); }
  };

  const handleDeleteTheme = async (id, e) => {
    e.stopPropagation();
    try {
      await fetch(`${API_URL}/seo/config/themes/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      fetchBaseData();
      if (selectedThemeId === id) setSelectedThemeId('all');
    } catch(e) { console.error(e); }
  };

  const handleAiTagging = async () => {
    if (selectedKeywordIds.length === 0) return;
    try {
      setIsKeywordsLoading(true);
      // Chunking to prevent Cloudflare 100s timeout
      const chunkSize = 20;
      let successCount = 0;
      
      for (let i = 0; i < selectedKeywordIds.length; i += chunkSize) {
        const chunk = selectedKeywordIds.slice(i, i + chunkSize);
        const res = await fetch(`${API_URL}/seo/config/keywords/batch/ai-tagging`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({ keywordIds: chunk, brandProjectId: editingId })
        });
        
        if (res.ok) {
          successCount += chunk.length;
        } else {
          try {
            const err = await res.json();
            console.error("AI Tagging failed for chunk:", err);
            alert("部分打标失败：" + (err.error || 'AI服务异常'));
          } catch(e) {
            alert("AI连接超时或服务异常，但部分打标可能在后台继续执行。");
          }
          break; // Stop further chunks on error
        }
      }
      
      if (successCount > 0) {
        alert(`AI 智能批量打标完成！成功处理 ${successCount} 个词。`);
      }
      setSelectedKeywordIds([]);
      fetchKeywordsList();
        fetchBaseData();
    } catch(e) {
      console.error(e);
      alert("网络或AI服务异常，请求被拦截或超时。请稍后刷新查看。");
    } finally {
      setIsKeywordsLoading(false);
    }
  };

  const handleSubmitBulkUpdate = async () => {
    if (selectedKeywordIds.length === 0) return;
    try {
      const res = await fetch(`${API_URL}/seo/config/keywords/batch/update`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          keywordIds: selectedKeywordIds,
          updates: bulkEditForm
        })
      });
      if (res.ok) {
        setIsBulkEditing(false);
        setBulkEditForm({ keywordType: '', funnelStage: '', competitorId: '', themeId: '' });
        setSelectedKeywordIds([]);
        fetchKeywordsList();
        fetchBaseData();
      }
    } catch(e) { console.error(e); }
  };
  
  const handleBulkSaveKeywords = async () => {
    const rawKeywords = bulkKeywordText.split(/\r?\n/);
    const keywordsArray = Array.from(new Set(rawKeywords.map(k => k.trim()).filter(k => k)));
    if (keywordsArray.length === 0) return setIsBulkAddingKeyword(false);
    
    if (!editingId) {
      alert("⚠️ 请先点击右上角「保存配置」完成项目创建，然后再批量录入关键词！");
      return;
    }
    
    try {
      const res = await fetch(`${API_URL}/seo/config/keywords/batch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          brandProjectId: editingId,
          themeId: selectedThemeId === 'all' || selectedThemeId === 'unassigned' ? null : selectedThemeId,
          keywords: keywordsArray
        })
      });
      if (res.ok) {
        setBulkKeywordText('');
        setIsBulkAddingKeyword(false);
        fetchKeywordsList();
        fetchBaseData();
      }
    } catch(e) { console.error(e); }
  };


  const handleSave = async () => {
    const clientMediaUrlEl = document.getElementById('clientMediaUrl');
    if (clientMediaUrlEl && clientMediaUrlEl.value.trim() !== '') {
      alert('⚠️ 您在【自有媒体矩阵】中填写了链接但尚未添加。\n\n请先点击旁边的「添加记录」按钮，然后再保存整体设置。');
      return;
    }

    if (!brand.name) {
      alert('请输入品牌/项目名称');
      return;
    }

    const payload = {
      targetUserId: brand.targetUserId,
      name: brand.name,
      subBrandName: brand.subBrandName,
      aliases: brand.aliases,
      website: brand.website,
      logo: brand.logo,
      products: brand.products,
      system: 'seo', // Mark explicitly as SEO project
      // themes: brand.themes, // Do not send themes in PUT so backend skips recreating them
      personas: brand.personas,
      competitors: competitors,
      collaborators: collaborators,
      keywordMode,
      keywords,
      classifiedKeywords,
      alertConfig: JSON.stringify(alertConfig),
      keywordPackages,
      productMappingMode,
      productMappings
    };

    try {
      
      const token = localStorage.getItem('token') || '';
      let url = `${API_URL}/brand-projects`;
      let method = 'POST';

      if (editingId) {
        url = `${API_URL}/brand-projects/${editingId}`;
        method = 'PUT';
      }

      const res = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.success) {
        await fetchProjects();
        if (data.data) {
          handleEdit(data.data);
        }
        alert("保存成功！");
      } else {
        alert("保存失败：" + (data.error || "未知错误"));
      }
    } catch (err) {
      console.error(err);
      alert("保存出错");
    } 
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    if(confirm('确定要删除这个项目配置吗？')) {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/brand-projects/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
          fetchProjects();
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const addCompetitor = () => {
    setCompetitors([...competitors, { id: Date.now(), name: '', aliases: '', website: '', products: '' }]);
  };

  const updateCompetitor = (id, field, value) => {
    setCompetitors(competitors.map(c => c.id === id ? { ...c, [field]: value } : c));
  };

  const removeCompetitor = (id) => {
    setCompetitors(competitors.filter(c => c.id !== id));
  };

  // Keyword Package Handlers
  const addKeywordPackage = () => {
    setKeywordPackages([...keywordPackages, { id: Date.now(), name: `新词包 ${keywordPackages.length + 1}`, items: [{ id: Date.now()+1, core: '', expansions: '' }] }]);
  };

  const removeKeywordPackage = (pkgId) => {
    setKeywordPackages(keywordPackages.filter(p => p.id !== pkgId));
  };

  const addPackageItem = (pkgId) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return { ...pkg, items: [...pkg.items, { id: Date.now(), core: '', expansions: '' }] };
      }
      return pkg;
    }));
  };

  const removePackageItem = (pkgId, itemId) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return { ...pkg, items: pkg.items.filter(item => item.id !== itemId) };
      }
      return pkg;
    }));
  };

  const updatePackageItem = (pkgId, itemId, field, value) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return {
          ...pkg,
          items: pkg.items.map(item => item.id === itemId ? { ...item, [field]: value } : item)
        };
      }
      return pkg;
    }));
  };

  const updatePackageName = (pkgId, name) => {
    setKeywordPackages(keywordPackages.map(pkg => pkg.id === pkgId ? { ...pkg, name } : pkg));
  };

  // --- Render List View ---

  const computeTotalKeywords = (project) => {
    return project.seoKeywords ? project.seoKeywords.length : 0;
  };

const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  if (view === 'list') {
    return (
      <div className="space-y-6 max-w-full p-2">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">SEO项目配置中心</h1>
            <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">管理 SEO 维度的品牌、竞品、词库及自有媒体阵地。</p>
          </div>
          <div className="flex space-x-3">
            {!editingId && <button onClick={() => setIsAiWizardOpen(true)} className="flex items-center space-x-2 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-4 py-2 rounded-lg transition-colors shadow-sm">
              <Sparkles size={16} />
              <span>AI 智能建项</span>
            </button>}
            <button onClick={() => setIsImportModalOpen(true)} className="flex items-center space-x-2 bg-white dark:bg-slate-700 hover:bg-gray-50 dark:hover:bg-slate-600 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-slate-600 px-4 py-2 rounded-lg transition-colors shadow-sm">
              <Upload size={16} />
              <span>批量导入</span>
            </button>
            <button onClick={handleCreate} className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors shadow-sm">
              <Plus size={16} />
              <span>新建监控项目</span>
            </button>
          </div>
        </div>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-32 space-y-4">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-500"></div>
            <p className="text-gray-500 dark:text-slate-400 text-sm">正在加载 SEO 监控项目...</p>
          </div>
        ) : projects.length === 0 ? (
          <div className="text-center py-24 bg-white dark:bg-slate-800/50 rounded-2xl border border-dashed border-gray-200 dark:border-slate-700 animate-in fade-in duration-500">
            <div className="w-16 h-16 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <Sparkles size={28} />
            </div>
            <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">暂无任何 SEO 监控项目</h3>
            <p className="text-sm text-gray-500 dark:text-slate-400 mb-6 max-w-md mx-auto">
              您还没有创建任何品牌的 SEO 监控矩阵。建议使用「AI 智能建项」一键生成完整的业务词包与 3D 关键词库。
            </p>
            <button onClick={() => setIsAiWizardOpen(true)} className="inline-flex items-center space-x-2 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white px-6 py-2.5 rounded-xl transition-all shadow-md font-medium">
              <Sparkles size={16} />
              <span>立即体验 AI 黑盒建项</span>
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {projects.map((project) => (
            <div 
              key={project.id} 
              onClick={() => handleEdit(project)}
              className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 p-6 cursor-pointer hover:shadow-md hover:border-indigo-300 dark:hover:border-indigo-500/50 transition-all group"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center space-x-3">
                  {project.logo ? (
                    <img src={project.logo.startsWith('/') ? project.logo : project.logo} alt={project.name} className="w-10 h-10 rounded-full object-contain bg-white border border-gray-200 dark:border-slate-700" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold text-lg">
                      {project.name.charAt(0)}
                    </div>
                  )}
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 dark:text-slate-100 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">{project.name}{project.subBrandName ? project.subBrandName : ''} </h3>
                    <p className="text-xs text-gray-500 dark:text-slate-400">最后更新: {new Date(project.updatedAt || project.createdAt || Date.now()).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '-')}</p>
                  </div>
                </div>
                <button onClick={(e) => handleDelete(e, project.id)} className="text-gray-400 hover:text-red-500 p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors opacity-0 group-hover:opacity-100">
                  <Trash2 size={16} />
                </button>
              </div>

              <div className="space-y-3">
                                {currentUser.role === 'ADMIN' && project.user && (
                  <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                    <span className="text-gray-500 dark:text-slate-400 w-20">所有者:</span>
                    <span className="text-gray-900 dark:text-slate-200 font-medium">{project.user.name}</span>
                  </div>
                )}
                <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                  <span className="text-gray-500 dark:text-slate-400 w-20">竞品数量:</span>
                  <span className="text-gray-900 dark:text-slate-200 font-medium">{project.competitors.length} 个</span>
                </div>
                <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                  <span className="text-gray-500 dark:text-slate-400 w-20">监控词库:</span>
                  <span className="text-gray-900 dark:text-slate-200 font-medium">{computeTotalKeywords(project)} 个关键词</span>
                                </div>
              </div>
            </div>
          ))}
          </div>
        )}
        
      <SeoAiWizardModal 
        isOpen={isAiWizardOpen} 
        onClose={() => setIsAiWizardOpen(false)} 
        onComplete={async (resData) => {
          setIsAiWizardOpen(false);
          const allProjects = await fetchProjects() || [];
          const targetProject = allProjects.find(p => p.id === resData.brandId);
          if (targetProject) {
            handleEdit(targetProject);
            setView('edit');
            setActiveTab('basic');
          } else {
            alert('获取 AI 创建的项目失败，请在列表中手动刷新');
          }
        }}
      />
      <ImportBrandModal 
        system="seo"
        isOpen={isImportModalOpen} 
        onClose={() => setIsImportModalOpen(false)} 
        onImportSuccess={() => {
          fetchProjects();
        }}
      />

      </div>
    );
  }

  // --- Render Edit Form View ---
  return (
    <div className="space-y-6 max-w-full p-2 animate-in fade-in duration-200">
      <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-slate-700 pb-4">
        <div className="flex items-center space-x-4">
          <button onClick={() => setView('list')} className="p-2 text-gray-500 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white bg-gray-100 hover:bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg transition-colors">
            <ArrowLeft size={18} />
          </button>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">
            {editingId ? '编辑品牌项目' : '新建监控项目'}
          </h1>
        </div>
        <div className="flex space-x-3">
          
          <button onClick={handleSave} className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg transition-colors shadow-sm">
            <Save size={16} />
            <span>保存配置</span>
          </button>
        </div>
      </div>

      
      {/* Tabs Navigation */}
      <div className="flex border-b border-gray-200 dark:border-slate-700 mb-6 overflow-x-auto custom-scrollbar">
        {[
          { id: 'basic', label: '基础设置 (本品&竞品)' },
          { id: 'themes', label: '业务维度配置' },
          { id: 'keywords', label: 'SEO词库配置' },
          { id: 'alerts', label: '预警中心配置' },
          { id: 'clientMedia', label: '自有媒体矩阵' }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === tab.id ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400' : 'border-transparent text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300'}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'basic' && (

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 animate-in fade-in duration-200">
        {/* Left Column: Brand Config */}
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-4 border-b border-gray-100 dark:border-slate-700 pb-2">本品设置</h2>
          <div className="space-y-4">
            {JSON.parse(localStorage.getItem('user') || '{}').role === 'ADMIN' && (
              <div className="col-span-2 bg-indigo-50/50 dark:bg-indigo-900/10 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800/30">
                <label className="block text-sm font-medium text-indigo-800 dark:text-indigo-300 mb-1">
                  归属客户 (仅超管可见)
                </label>
                <select
                  value={brand.targetUserId || ''}
                  onChange={(e) => setBrand({ ...brand, targetUserId: e.target.value })}
                  className="w-full px-4 py-2 border border-indigo-200 dark:border-indigo-700/50 rounded-lg focus:ring-2 focus:ring-indigo-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100"
                >
                  <option value="" className="bg-white text-gray-900 dark:bg-slate-800 dark:text-gray-200">您自己 (默认所有者)</option>
                  {allUsers.map(u => (
                    <option key={u.id} value={u.id} className="bg-white text-gray-900 dark:bg-slate-800 dark:text-gray-200">{u.name} ( {u.role} )</option>
                  ))}
                </select>
                <p className="text-xs text-indigo-600/70 dark:text-indigo-400/70 mt-1">如果帮客户代劳配置，请在此选择客户账号。保存后，客户登录即可直接使用该配置。</p>
              </div>
            )}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">主品牌名称</label>
                <input 
                  type="text" 
                  value={brand.name} 
                  onChange={(e) => setBrand({...brand, name: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: 特斯拉"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">子品牌名</label>
                <input 
                  type="text" 
                  value={brand.subBrandName || ''} 
                  onChange={(e) => setBrand({...brand, subBrandName: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: 07 (荣威07)"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">品牌别名/同义词 (支持逗号、顿号)</label>
                <input 
                  type="text" 
                  value={brand.aliases}
                  onChange={(e) => setBrand({...brand, aliases: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: Tesla, TSLA"
                />
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">本品产品 / 核心防控产品词 (请通过回车换行隔离)</label>
                <textarea 
                  value={brand.products || ''}
                  onChange={(e) => setBrand({...brand, products: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none min-h-[80px]"
                  placeholder="例如: 星趣控, 钻囊, 膜岩"
                />
                <p className="text-[10px] text-gray-500 mt-1">配置后，如果舆情未提及品牌，但提及了上述产品，AI 也将精准识别为本品舆情防线的一部分。</p>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">品牌 Logo</label>
                <div className="flex space-x-2">
                  <div className="flex-1 flex space-x-2">
                    {brand.logo && (
                      <div className="w-10 h-10 rounded bg-white border border-gray-200 dark:border-slate-700 overflow-hidden flex items-center justify-center shrink-0">
                        <img src={brand.logo.startsWith('/') ? brand.logo : brand.logo} alt="Logo" className="max-w-full max-h-full object-contain" />
                      </div>
                    )}
                    <input 
                      type="text" 
                      value={brand.logo || ''}
                      onChange={(e) => setBrand({...brand, logo: e.target.value})}
                      className="flex-1 px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      placeholder="URL 或点击右侧上传"
                    />
                    <label className="cursor-pointer bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg text-sm flex items-center justify-center transition-colors shrink-0">
                      <span>上传</span>
                      <input type="file" className="hidden" accept="image/*" onChange={(e) => handleUploadImage(e, false)} />
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">官方网站 (可选)</label>
                <input 
                  type="text" 
                  value={brand.website}
                  onChange={(e) => setBrand({...brand, website: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: tesla.cn"
                />
              </div>
            </div>

            {colleagues.length > 0 && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                  协作者 <span className="text-xs text-gray-400 font-normal ml-1">(允许同组的其他同事查看并管理该项目的数据)</span>
                </label>
                <div className="flex flex-wrap gap-2 p-3 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg max-h-32 overflow-y-auto">
                  {colleagues.map(user => (
                    <label key={user.id} className="inline-flex items-center space-x-2 mr-4 mb-2 cursor-pointer">
                      <input 
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                        checked={collaborators.includes(user.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setCollaborators([...collaborators, user.id]);
                          } else {
                            setCollaborators(collaborators.filter(id => id !== user.id));
                          }
                        }}
                      />
                      <span className="text-sm text-gray-700 dark:text-slate-300">{user.name}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            
            {/* 官方社媒账号配置 */}
            <div className="mt-4 pt-4 border-t border-gray-100 dark:border-slate-700/50">
              <div 
                className="flex items-center cursor-pointer select-none"
                onClick={() => setShowSocialMedia(!showSocialMedia)}
              >
                {showSocialMedia ? <ChevronDown className="w-4 h-4 text-gray-500 mr-2" /> : <ChevronRight className="w-4 h-4 text-gray-500 mr-2" />}
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 cursor-pointer">
                  官方社交账号/标识 <span className="text-xs text-gray-400 font-normal ml-1">(用于系统自动识别并过滤官方发声，确保大盘反映真实用户舆情)</span>
                </label>
              </div>
              
              {showSocialMedia && (
                <div className="grid grid-cols-2 gap-3 mt-3">
                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">微博</span>
                    </div>
                    <input 
                      type="text" 
                      value={(brand.socialMedia ? brand.socialMedia.weibo : '') || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, weibo: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="UID或精确主页名"
                    />
                  </div>
                  
                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">抖音</span>
                    </div>
                    <input 
                      type="text" 
                      value={(brand.socialMedia ? brand.socialMedia.douyin : '') || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, douyin: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="抖音号"
                    />
                  </div>

                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden opacity-60">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-400 dark:text-slate-500">小红书</span>
                    </div>
                    <input 
                      type="text" 
                      disabled
                      value={(brand.socialMedia ? brand.socialMedia.xhs : '') || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, xhs: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-400 dark:text-slate-500 outline-none cursor-not-allowed"
                      placeholder="小红书号 (暂未开放)"
                    />
                  </div>

                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">公众号</span>
                    </div>
                    <input 
                      type="text" 
                      value={(brand.socialMedia ? brand.socialMedia.wechat : '') || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, wechat: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="微信号"
                    />
                  </div>
                </div>
              )}
            </div>

            
          </div>
        </div>

        {/* Right Column: Competitor Config */}
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50">
          <div className="flex justify-between items-center mb-4 border-b border-gray-100 dark:border-slate-700 pb-2">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">竞品设置</h2>
            <button onClick={addCompetitor} className="text-sm flex items-center text-indigo-600 dark:text-indigo-400 hover:text-indigo-700">
              <Plus size={16} className="mr-1" /> 添加竞品
            </button>
          </div>
          
          <div className="space-y-4 max-h-[520px] overflow-y-auto pr-2 custom-scrollbar">
            {competitors.map((comp, index) => (
              <div key={comp.id} className="flex space-x-3 items-start p-3 bg-gray-50 dark:bg-slate-900/30 rounded-lg border border-gray-100 dark:border-slate-700/50 relative group">
                <div className="flex-1 space-y-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">竞品 {index + 1} 名称</label>
                      <input 
                        type="text" 
                        value={comp.name}
                        onChange={(e) => updateCompetitor(comp.id, 'name', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">别名/同义词 (支持逗号、顿号)</label>
                      <input 
                        type="text" 
                        value={comp.aliases}
                        onChange={(e) => updateCompetitor(comp.id, 'aliases', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-3 mt-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">竞品 Logo</label>
                      <div className="flex space-x-2">
                        {comp.logo && (
                          <div className="w-8 h-8 rounded bg-white border border-gray-200 dark:border-slate-700 overflow-hidden flex items-center justify-center shrink-0">
                            <img src={comp.logo.startsWith('/') ? comp.logo : comp.logo} alt="Logo" className="max-w-full max-h-full object-contain" />
                          </div>
                        )}
                        <input 
                          type="text" 
                          value={comp.logo || ''}
                          onChange={(e) => updateCompetitor(comp.id, 'logo', e.target.value)}
                          className="flex-1 px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                          placeholder="图片 URL 或上传"
                        />
                        <label className="cursor-pointer bg-slate-700 hover:bg-slate-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center justify-center transition-colors shrink-0">
                          <span>上传</span>
                          <input type="file" className="hidden" accept="image/*" onChange={(e) => handleUploadImage(e, true, comp.id)} />
                        </label>
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">官方网站 (可选)</label>
                      <input 
                        type="text" 
                        value={comp.website || ''}
                        onChange={(e) => updateCompetitor(comp.id, 'website', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                        placeholder="例如: byd.com"
                      />
                    </div>
                  </div>
                </div>
                <button onClick={() => removeCompetitor(comp.id)} className="p-1.5 text-gray-400 hover:text-red-500 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors mt-6">
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
            {competitors.length === 0 && (
              <p className="text-sm text-gray-500 dark:text-slate-400 text-center py-4">暂无竞品，点击右上角添加。</p>
            )}
          </div>
        </div>
      </div>
      )}

            {/* Full Width: Product Matrix (Optional Advanced Setup) */}

      {activeTab === 'themes' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 mb-8 overflow-hidden animate-in fade-in duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">核心业务维度 (宏观+微观 双层架构)</h2>
          <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">设置宏观一级指标（建议不超过6个，用于雷达图），并在其下挂载微观细分维度（用于热力图）。</p>
        </div>
        <div className="p-6 space-y-6">
          {(brand.themes || []).map((theme, tIdx) => (
            <div key={theme.id || tIdx} className="border border-gray-200 dark:border-slate-700/60 rounded-xl overflow-hidden">
              {/* Level 1 Header */}
              <div className="flex items-center justify-between bg-slate-50 dark:bg-slate-800/80 p-4 border-b border-gray-200 dark:border-slate-700/60">
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-500/20 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold text-sm">
                    {tIdx + 1}
                  </div>
                  <input 
                    type="text"
                    value={theme.name}
                    onChange={(e) => {
                      const newThemes = [...(brand.themes || [])];
                      newThemes[tIdx].name = e.target.value;
                      setBrand({...brand, themes: newThemes});
                    }}
                    placeholder="一级宏观指标（如：舒适静音）"
                    className="flex-1 max-w-sm px-3 py-1.5 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm font-medium focus:border-indigo-500 outline-none dark:text-white text-gray-900 dark:text-slate-200"
                  />
                </div>
                <button 
                  onClick={() => {
                    const newThemes = [...(brand.themes || [])];
                    newThemes.splice(tIdx, 1);
                    setBrand({...brand, themes: newThemes});
                  }}
                  className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              
              {/* Level 2 Sub-themes */}
              <div className="p-4 bg-white dark:bg-slate-900/30">
                <div className="grid grid-cols-12 gap-4 mb-2 px-2 text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  <div className="col-span-4">二级细分指标 (微观卖点)</div>
                  <div className="col-span-7">包含的特征词/同义词</div>
                  <div className="col-span-1 text-center">操作</div>
                </div>
                
                <div className="space-y-2">
                  {(theme.subThemes || []).map((sub, sIdx) => (
                    <div key={sub.id || sIdx} className="grid grid-cols-12 gap-4 items-start bg-gray-50 dark:bg-slate-800/50 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700/50">
                      <div className="col-span-4">
                        <input 
                          type="text" 
                          value={sub.name}
                          onChange={(e) => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes[sIdx].name = e.target.value;
                            setBrand({...brand, themes: newThemes});
                          }}
                          placeholder="如: 胎噪抑制表现"
                          className="w-full px-3 py-1.5 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-md text-sm focus:border-indigo-500 dark:text-slate-200 outline-none"
                        />
                      </div>
                      <div className="col-span-7">
                        <input 
                          type="text" 
                          value={sub.keywords}
                          onChange={(e) => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes[sIdx].keywords = e.target.value;
                            setBrand({...brand, themes: newThemes});
                          }}
                          placeholder="如: 胎噪, 静音好, 没声音"
                          className="w-full px-3 py-1.5 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-md text-sm focus:border-indigo-500 dark:text-slate-200 outline-none"
                        />
                      </div>
                      <div className="col-span-1 flex justify-center mt-1">
                        <button 
                          onClick={() => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes.splice(sIdx, 1);
                            setBrand({...brand, themes: newThemes});
                          }}
                          className="p-1 text-slate-400 hover:text-red-500 transition-colors"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))}
                  
                  <button 
                    onClick={() => {
                      const newThemes = [...(brand.themes || [])];
                      if (!newThemes[tIdx].subThemes) newThemes[tIdx].subThemes = [];
                      newThemes[tIdx].subThemes.push({ id: Date.now(), name: '', keywords: '' });
                      setBrand({...brand, themes: newThemes});
                    }}
                    className="mt-2 flex items-center px-3 py-1.5 text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 rounded-md transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5 mr-1" /> 添加二级细分指标
                  </button>
                </div>
              </div>
            </div>
          ))}
          
          <button 
            onClick={() => {
              const newThemes = [...(brand.themes || [])];
              newThemes.push({ id: Date.now(), name: '', subThemes: [{ id: Date.now()+1, name: '', keywords: '' }] });
              setBrand({...brand, themes: newThemes});
            }}
            className="w-full py-3 border-2 border-dashed border-indigo-200 dark:border-indigo-500/30 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 rounded-xl flex items-center justify-center font-medium transition-colors"
          >
            <Plus className="w-5 h-5 mr-2" /> 新增一级宏观指标
          </button>
        </div>
      </div>
      )}
      {activeTab === 'keywords' && (
        <div className="bg-white dark:bg-slate-800/80 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden min-h-[500px]">
          <div className="p-6">
            <h3 className="font-bold text-gray-900 dark:text-white mb-2">业务线及词包配置</h3>
            <p className="text-sm text-gray-500 dark:text-slate-400 mb-6">AI 抓取任务将基于您在左侧勾选的词包结构，在对应引擎执行自动探测。</p>
            
            <div className="flex h-[600px] border border-gray-200 dark:border-slate-700 rounded-xl overflow-hidden">
               {/* Left sidebar: Themes */}
               <div className="w-64 bg-gray-50 dark:bg-slate-900/50 border-r border-gray-200 dark:border-slate-700 flex flex-col">
                  <div className="p-3 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center">
                    <span className="font-semibold text-sm text-gray-700 dark:text-slate-300">词包目录</span>
                    <button onClick={handleAddTheme} className="p-1 hover:bg-gray-200 dark:hover:bg-slate-800 rounded">
                      <Plus size={14} className="text-indigo-600 dark:text-indigo-400" />
                    </button>
                  </div>
                  <div className="flex-1 overflow-y-auto custom-scrollbar">
                    <button 
                      onClick={() => setSelectedThemeId('all')} 
                      className={`w-full text-left px-4 py-3 text-sm transition-colors border-l-2 flex justify-between items-center ${selectedThemeId === 'all' ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                    >
                      <span>全部关键词</span>
                      <span className="text-xs bg-gray-200 dark:bg-slate-700 px-2 py-0.5 rounded-full">{keywordCounts.total}</span>
                    </button>
                    
                    {/* Categorized Collapsible */}
                    <div className="border-b border-gray-100 dark:border-slate-800">
                      <button
                        onClick={() => setIsCategorizedExpanded(!isCategorizedExpanded)}
                        className="w-full text-left px-4 py-2 text-xs font-semibold text-gray-500 dark:text-slate-400 bg-gray-50 dark:bg-slate-900/50 hover:bg-gray-100 dark:hover:bg-slate-800/80 flex items-center transition-colors"
                      >
                        {isCategorizedExpanded ? <ChevronDown size={14} className="mr-1" /> : <ChevronRight size={14} className="mr-1" />}
                        已分类 ({themes.length})
                      </button>
                      
                      {isCategorizedExpanded && isAddingTheme === true && (
                        <div className="w-full text-left pl-8 pr-4 py-2.5 border-l-2 border-transparent">
                          <input 
                            autoFocus
                            type="text" 
                            placeholder="输入新词包名称"
                            value={newThemeName}
                            onChange={(e) => setNewThemeName(e.target.value)}
                            onBlur={() => handleCreateTheme(newThemeName)}
                            onKeyDown={(e) => { if(e.key === 'Enter') { handleCreateTheme(newThemeName); } }}
                            className="w-full bg-white dark:bg-slate-700 border border-indigo-500 outline-none px-2 py-1 rounded text-gray-900 dark:text-slate-100 text-sm"
                          />
                        </div>
                      )}
                      
                      {isCategorizedExpanded && themes.map(t => (
                        <button 
                          key={t.id}
                          onClick={() => setSelectedThemeId(t.id)} 
                          className={`w-full text-left pl-8 pr-4 py-2.5 text-sm transition-colors border-l-2 flex justify-between items-center group ${selectedThemeId === t.id ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                        >
                          {isAddingTheme === t.id ? (
                             <input 
                                autoFocus
                                type="text" 
                                defaultValue={t.name}
                                onBlur={(e) => { setIsAddingTheme(false); if(e.target.value !== t.name) handleUpdateTheme(t.id, e.target.value); }}
                                onKeyDown={(e) => { if(e.key === 'Enter') { setIsAddingTheme(false); if(e.target.value !== t.name) handleUpdateTheme(t.id, e.target.value); } }}
                                className="w-full bg-white dark:bg-slate-700 border border-indigo-500 outline-none px-1 rounded text-gray-900 dark:text-slate-100"
                             />
                          ) : (
                             <span className="truncate pr-2" onDoubleClick={() => setIsAddingTheme(t.id)}>{t.name}</span>
                          )}
                          <span className="text-xs text-gray-400 group-hover:hidden flex-shrink-0">{t._count?.seoKeyword || 0}</span>
                          <Trash2 size={12} onClick={(e) => handleDeleteTheme(t.id, e)} className="text-gray-400 hover:text-red-500 hidden group-hover:block flex-shrink-0" />
                        </button>
                      ))}
                    </div>

                    <button 
                      onClick={() => setSelectedThemeId('unassigned')} 
                      className={`w-full text-left px-4 py-3 text-sm transition-colors border-l-2 flex justify-between items-center group ${selectedThemeId === 'unassigned' ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                    >
                      <span className="truncate pr-2 font-medium">未分类词汇</span>
                      <span className="text-xs bg-gray-200 dark:bg-slate-700 px-2 py-0.5 rounded-full">{keywordCounts.unassigned}</span>
                    </button>
                  </div>
               </div>
               
               {/* Right side: Keywords */}
               <div className="flex-1 bg-white dark:bg-slate-800 flex flex-col min-w-0">
                 <div className="p-3 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/30 overflow-x-auto">
                    <div className="flex items-center space-x-2 shrink-0">
                      <button onClick={handleAddKeyword} className="flex items-center space-x-1 px-3 py-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-md text-xs font-medium hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors shrink-0">
                        <Plus size={14} /> <span>添加关键词</span>
                      </button>
                      <button onClick={() => setIsBulkAddingKeyword(true)} className="flex items-center space-x-1 px-3 py-1.5 bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-slate-300 rounded-md text-xs font-medium hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors shrink-0">
                        <Copy size={14} /> <span>高级录入</span>
                      </button>
                      <button onClick={() => setAiExpandState({isOpen: true, themeName: selectedThemeId === 'all' || selectedThemeId === 'unassigned' ? '' : (themes.find(t=>t.id===selectedThemeId) ? themes.find(t=>t.id===selectedThemeId).name : ''), packageId: selectedThemeId === 'all' || selectedThemeId === 'unassigned' ? null : selectedThemeId})} className="flex items-center space-x-1 px-3 py-1.5 bg-gradient-to-r from-emerald-400 to-teal-500 text-white rounded-md text-xs font-medium hover:from-emerald-500 hover:to-teal-600 transition-colors shadow-sm shrink-0">
                        <Sparkles size={14} /> <span>AI 智能拓词</span>
                      </button>
                    </div>
                    <div className="flex items-center space-x-2 shrink-0 ml-4">
                      <button onClick={handleAiTagging} disabled={selectedKeywordIds.length === 0} className="flex items-center space-x-1 px-3 py-1.5 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-md text-xs font-medium hover:from-purple-600 hover:to-indigo-700 transition-colors shadow-sm disabled:opacity-50 shrink-0">
                        <Sparkles size={14} /> <span>一键批量打标</span>
                      </button>
                      <button onClick={() => setIsBulkEditing(true)} disabled={selectedKeywordIds.length === 0} className="flex items-center space-x-1 px-3 py-1.5 bg-gray-100 dark:bg-slate-800 text-gray-700 dark:text-slate-300 rounded-md text-xs font-medium hover:bg-gray-200 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 shrink-0">
                        <Edit size={14} /> <span>批量修改属性</span>
                      </button>
                    </div>
                 </div>
                 
                 <div className="flex-1 overflow-x-auto overflow-y-auto custom-scrollbar relative">
                   {isKeywordsLoading ? (
                     <div className="absolute inset-0 flex items-center justify-center bg-white/50 dark:bg-slate-800/50 z-10">
                       <span className="text-gray-500">加载中...</span>
                     </div>
                   ) : (
                     <table className="w-full text-left border-collapse min-w-[800px]">
                       <thead>
                         <tr className="bg-gray-50 dark:bg-slate-900/80 sticky top-0 z-10 shadow-sm">
                           <th className="px-4 py-3 w-10">
                             <input type="checkbox" className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 bg-white dark:bg-slate-700 dark:border-slate-600" onChange={handleToggleAllKeywords} checked={keywordsList.length > 0 && selectedKeywordIds.length === keywordsList.length} />
                           </th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap min-w-[200px]">关键词</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">全网搜索量</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">归属业务维度</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">词汇属性配置</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">归属竞品(针对拦截)</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">SICAS 所属阶段</th>
                           <th className="px-4 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 text-right whitespace-nowrap">操作</th>
                         </tr>
                       </thead>
                       <tbody className="divide-y divide-gray-100 dark:divide-slate-700/50">
                         {keywordsList.map(kw => (
                           <tr key={kw.id} className="hover:bg-gray-50/50 dark:hover:bg-slate-700/20">
                             <td className="px-4 py-3">
                               <input type="checkbox" className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 bg-white dark:bg-slate-700 dark:border-slate-600" checked={selectedKeywordIds.includes(kw.id)} onChange={() => handleToggleKeyword(kw.id)} />
                             </td>
                             <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-200 whitespace-nowrap" title={kw.keyword}>
                               <input 
                                  type="text" 
                                  value={kw.keyword}
                                  title={kw.keyword}
                                  onChange={(e) => {
                                      setKeywordsList(prev => prev.map(k => k.id === kw.id ? { ...k, keyword: e.target.value } : k));
                                  }}
                                  onBlur={(e) => handleUpdateKeyword(kw.id, 'keyword', e.target.value)}
                                  onKeyDown={(e) => { if (e.key === 'Enter') { e.target.blur(); } }}
                                  placeholder="请输入..." autoFocus={kw.keyword === ''} className="w-full bg-transparent border-b border-gray-300 dark:border-slate-600 hover:border-indigo-400 focus:border-indigo-500 outline-none px-1 py-0.5 transition-colors placeholder-gray-400"
                               />
                             </td>
                             <td className="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
                               <div className="flex items-center space-x-2">
                                  {kw.searchVolume ? (
                                    <span className="flex items-center gap-1.5 px-2 py-0.5 bg-gray-50 dark:bg-slate-800 rounded-full text-xs font-medium border border-gray-100 dark:border-slate-700">
                                      <span className={`w-2 h-2 rounded-full ${kw.searchVolume > 800 ? 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.6)]' : kw.searchVolume > 300 ? 'bg-orange-400' : 'bg-slate-400'}`}></span>
                                      <span className={kw.searchVolume > 800 ? 'text-rose-600 dark:text-rose-400' : kw.searchVolume > 300 ? 'text-orange-600 dark:text-orange-400' : 'text-slate-500 dark:text-slate-400'}>
                                        {kw.searchVolume > 800 ? '高' : kw.searchVolume > 300 ? '中' : '低'}
                                      </span>
                                    </span>
                                  ) : (
                                    <span className="flex items-center gap-1.5 px-2 py-0.5 bg-gray-50 dark:bg-slate-800 rounded-full text-xs font-medium border border-gray-100 dark:border-slate-700">
                                      <span className="w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-600"></span>
                                      <span className="text-slate-400">未知</span>
                                    </span>
                                  )}
                               </div>
                             </td>
                             <td className="px-4 py-3 whitespace-nowrap">
                               <select 
                                 value={kw.themeId || ''}
                                 onChange={(e) => handleUpdateKeyword(kw.id, 'themeId', e.target.value)}
                                 className="text-xs px-2 py-1 bg-transparent border border-gray-200 dark:border-slate-700 rounded outline-none cursor-pointer text-gray-700 dark:text-gray-300 max-w-[120px]"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--未分类--</option>
                                 {themes.map(t => (
                                   <option key={t.id} value={t.id} className="bg-white dark:bg-slate-800 truncate">{t.name}</option>
                                 ))}
                               </select>
                             </td>
                             <td className="px-4 py-3 whitespace-nowrap">
                               <select 
                                 value={kw.keywordType || 'category'}
                                 onChange={(e) => handleUpdateKeyword(kw.id, 'keywordType', e.target.value)}
                                 className={`text-xs px-2 py-1 rounded outline-none cursor-pointer ${
                                   kw.keywordType === 'brand' ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300' :
                                   kw.keywordType === 'competitor' ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300' :
                                   'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300'
                                 }`}
                               >
                                 <option value="brand" className="bg-white dark:bg-slate-800 text-gray-900 dark:text-white">品牌词</option>
                                 <option value="competitor" className="bg-white dark:bg-slate-800 text-gray-900 dark:text-white">竞品词</option>
                                 <option value="category" className="bg-white dark:bg-slate-800 text-gray-900 dark:text-white">通用词</option>
                                 <option value="compare" className="bg-white dark:bg-slate-800 text-gray-900 dark:text-white">对比词</option>
                               </select>
                             </td>
                             <td className="px-4 py-3 whitespace-nowrap">
                               <select 
                                 value={kw.competitorId || ''}
                                 onChange={(e) => handleUpdateKeyword(kw.id, 'competitorId', e.target.value)}
                                 disabled={kw.keywordType !== 'competitor'}
                                 className="text-xs px-2 py-1 bg-transparent border border-gray-200 dark:border-slate-700 rounded outline-none cursor-pointer text-gray-700 dark:text-gray-300 disabled:opacity-30 disabled:bg-gray-50 dark:disabled:bg-slate-800 max-w-[120px]"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--无--</option>
                                 {competitorsList.map(c => (
                                   <option key={c.id} value={c.id} className="bg-white dark:bg-slate-800 truncate">{c.name}</option>
                                 ))}
                               </select>
                             </td>
                             <td className="px-4 py-3 whitespace-nowrap">
                               {(function(){
                                 const sicasMap = { '认知':'Sense', '吸引':'Interest', '问询':'Connection', '行动':'Action', 'Awareness':'Sense', 'Appeal':'Interest', 'Ask':'Connection', 'Act':'Action', 'Action':'Action', 'Sense':'Sense', 'Interest':'Interest', 'Connection':'Connection', 'Share':'Share' };
                                 const displayValue = sicasMap[kw.funnelStage] || kw.funnelStage || 'Sense';
                                 return (
                                   <select 
                                     value={displayValue}
                                     onChange={(e) => handleUpdateKeyword(kw.id, 'funnelStage', e.target.value)}
                                     className="text-xs px-2 py-1 bg-transparent border border-gray-200 dark:border-slate-700 rounded outline-none cursor-pointer text-gray-700 dark:text-gray-300"
                                   >
                                     <option value="Sense" className="bg-white dark:bg-slate-800">感知 (Sense)</option>
                                     <option value="Interest" className="bg-white dark:bg-slate-800">兴趣 (Interest)</option>
                                     <option value="Connection" className="bg-white dark:bg-slate-800">连接 (Connection)</option>
                                     <option value="Action" className="bg-white dark:bg-slate-800">行动 (Action)</option>
                                     <option value="Share" className="bg-white dark:bg-slate-800">分享 (Share)</option>
                                     {(!['Sense','Interest','Connection','Action','Share'].includes(displayValue)) && (
                                       <option value={displayValue} className="bg-white dark:bg-slate-800">{displayValue}</option>
                                     )}
                                   </select>
                                 );
                               })()}
                             </td>
                             <td className="px-4 py-3 text-right">
                               <button onClick={() => handleDeleteKeyword(kw.id)} className="text-gray-400 hover:text-red-500 transition-colors">
                                 <Trash2 size={14} />
                               </button>
                             </td>
                           </tr>
                         ))}
                         {keywordsList.length === 0 && (
                           <tr>
                             <td colSpan="8" className="px-4 py-12 text-center text-gray-500 dark:text-slate-400">
                               暂无关键词。点击左上角添加，或使用 AI 智能拓词。
                             </td>
                           </tr>
                         )}
                       </tbody>
                     </table>
                   )}
                 </div>
               </div>
            </div>
          </div>
        </div>
      )}

      
        {/* Bulk Add Keywords Modal */}
        {isBulkAddingKeyword && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setIsBulkAddingKeyword(false)}></div>
            <div className="relative bg-white dark:bg-slate-900 w-full max-w-2xl h-[80vh] rounded-2xl shadow-2xl border border-gray-100 dark:border-slate-800 flex flex-col animate-in fade-in zoom-in-95 duration-200">
              <div className="p-4 border-b border-gray-100 dark:border-slate-800 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/50">
                <h3 className="font-bold text-gray-900 dark:text-white flex items-center">
                  <Copy className="w-4 h-4 mr-2 text-indigo-500" />
                  高级录入：批量添加关键词
                </h3>
                <button onClick={() => setIsBulkAddingKeyword(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
                  <X size={20} />
                </button>
              </div>
              <div className="p-4 flex-1 bg-white dark:bg-slate-800 flex flex-col">
                <p className="text-sm text-gray-500 dark:text-slate-400 mb-3">
                  请在此粘贴您的关键词列表。请每行输入一个完整的提问/提示词，系统将以换行符自动拆分。
                </p>
                <textarea
                  autoFocus
                  className="w-full flex-1 p-3 border border-gray-200 dark:border-slate-600 rounded-lg bg-gray-50/50 dark:bg-slate-900/50 text-sm text-gray-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-none shadow-inner"
                  placeholder="例如:\n手机\n笔记本,平板，耳机\n显示器"
                  value={bulkKeywordText}
                  onChange={e => setBulkKeywordText(e.target.value)}
                />
              </div>
              <div className="p-4 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-3 bg-gray-50 dark:bg-slate-800/50">
                <button onClick={() => setIsBulkAddingKeyword(false)} className="px-5 py-2 text-sm font-medium text-gray-700 dark:text-slate-300 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors shadow-sm">
                  取消
                </button>
                <button onClick={handleBulkSaveKeywords} className="px-5 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-lg hover:bg-indigo-700 transition-colors shadow-sm flex items-center gap-2">
                  <Plus className="w-4 h-4" /> 确认录入
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Bulk Edit Modal */}
        {isBulkEditing && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={() => setIsBulkEditing(false)}></div>
            <div className="relative bg-white dark:bg-slate-900 w-full max-w-md rounded-2xl shadow-2xl border border-gray-100 dark:border-slate-800 flex flex-col animate-in fade-in zoom-in-95 duration-200">
              <div className="p-4 border-b border-gray-100 dark:border-slate-800 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/50">
                <h3 className="font-bold text-gray-900 dark:text-white flex items-center">
                  <Edit className="w-4 h-4 mr-2 text-indigo-500" />
                  批量修改属性 (已选 {selectedKeywordIds.length} 项)
                </h3>
                <button onClick={() => setIsBulkEditing(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
                  <X size={20} />
                </button>
              </div>
              <div className="p-5 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">归属业务维度</label>
                  <select value={bulkEditForm.themeId} onChange={e => setBulkEditForm({...bulkEditForm, themeId: e.target.value})} className="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-indigo-500 dark:text-white">
                    <option value="">-- 不修改 --</option>
                    <option value="unassigned">未分类</option>
                    {themes.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">词汇属性 (品牌/通用/竞品)</label>
                  <select value={bulkEditForm.keywordType} onChange={e => setBulkEditForm({...bulkEditForm, keywordType: e.target.value})} className="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-indigo-500 dark:text-white">
                    <option value="">-- 不修改 --</option>
                    <option value="brand">品牌词</option>
                    <option value="category">通用词</option>
                    <option value="compare">对比词</option>
                    <option value="competitor">竞品词</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">归属竞品</label>
                  <select value={bulkEditForm.competitorId} onChange={e => setBulkEditForm({...bulkEditForm, competitorId: e.target.value})} className="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-indigo-500 dark:text-white">
                    <option value="">-- 不修改 --</option>
                    <option value="none">无 (清空归属)</option>
                    {competitorsList.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">所属 SICAS 阶段</label>
                  <select value={bulkEditForm.funnelStage} onChange={e => setBulkEditForm({...bulkEditForm, funnelStage: e.target.value})} className="w-full px-3 py-2 border border-gray-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-indigo-500 dark:text-white">
                    <option value="">-- 不修改 --</option>
                    <option value="Sense">感知 (Sense)</option>
                    <option value="Interest">兴趣 (Interest)</option>
                    <option value="Connection">连接 (Connection)</option>
                    <option value="Action">行动 (Action)</option>
                    <option value="Share">分享 (Share)</option>
                  </select>
                </div>
              </div>
              <div className="p-4 border-t border-gray-100 dark:border-slate-800 flex justify-end gap-3 bg-gray-50/50 dark:bg-slate-900/50">
                <button onClick={() => setIsBulkEditing(false)} className="px-4 py-2 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">取消</button>
                <button onClick={handleSubmitBulkUpdate} className="px-5 py-2 text-sm text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm">应用修改</button>
              </div>
            </div>
          </div>
        )}


      {activeTab === 'alerts' && (
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-8 rounded-2xl shadow-sm border border-red-100 dark:border-red-900/30 animate-in fade-in duration-200">
          <div className="mb-6 flex items-center gap-3">
            <div className="p-2 bg-red-100 dark:bg-red-500/20 text-red-600 dark:text-red-400 rounded-lg">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-slate-100">GEO Radar 预警设置</h2>
              <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">设置风险监控指标。当大盘数据出现异常跌幅时，通过 Webhook 自动推送报警信息。</p>
            </div>
          </div>

          <div className="space-y-8 max-w-4xl">
            {/* Webhook Configuration */}
            <div className="bg-slate-50 dark:bg-slate-900/50 p-6 rounded-xl border border-slate-200 dark:border-slate-700/50">
              <h3 className="text-sm font-semibold text-gray-800 dark:text-slate-200 mb-4 flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8c0 3.613-3.869 7.469-6 11-2.131-3.531-6-7.387-6-11a6 6 0 1 1 12 0z"/><circle cx="12" cy="8" r="2"/></svg>
                报警触达通道
              </h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
                  Webhook URL (支持飞书、钉钉、企业微信机器人)
                </label>
                <input
                  type="text"
                  value={alertConfig.webhook}
                  onChange={e => setAlertConfig({...alertConfig, webhook: e.target.value})}
                  placeholder="https://open.feishu.cn/open-apis/bot/v2/hook/..."
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm text-gray-900 dark:text-slate-100 placeholder-gray-400"
                />
              </div>
            </div>

            {/* Threshold Rules */}
            <div className="bg-slate-50 dark:bg-slate-900/50 p-6 rounded-xl border border-slate-200 dark:border-slate-700/50">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm font-semibold text-gray-800 dark:text-slate-200 flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
                  触发规则阈值
                </h3>
                <button
                  onClick={() => setAlertConfig({...alertConfig, rules: [...alertConfig.rules, {metric: 'negative', threshold: 15}]})}
                  className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 font-medium flex items-center gap-1"
                >
                  <Plus size={14}/> 添加规则
                </button>
              </div>

              <div className="space-y-4">
                {alertConfig.rules.map((rule, idx) => (
                  <div key={idx} className="flex items-center gap-4 bg-white dark:bg-slate-800 p-4 rounded-lg border border-gray-100 dark:border-slate-700">
                    <select
                      value={rule.metric}
                      onChange={e => {
                        const newRules = [...alertConfig.rules];
                        newRules[idx].metric = e.target.value;
                        setAlertConfig({...alertConfig, rules: newRules});
                      }}
                      className="w-1/3 px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100"
                    >
                      <option value="negative">🚨 负面评价占比激增 (大于)</option>
                      <option value="top1_drop">📉 品牌词首页占位率跌破 (小于)</option>
                      <option value="sov_drop">⚠️ 品牌提及率 (SOV) 跌破 (小于)</option>
                    </select>
                    
                    <div className="flex items-center gap-2 flex-1">
                      <span className="text-sm text-gray-500 dark:text-slate-400">{rule.metric === 'negative' ? '≥' : '≤'}</span>
                      <input
                        type="number"
                        value={rule.threshold}
                        onChange={e => {
                          const newRules = [...alertConfig.rules];
                          newRules[idx].threshold = parseFloat(e.target.value);
                          setAlertConfig({...alertConfig, rules: newRules});
                        }}
                        className="w-24 px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-center text-gray-900 dark:text-slate-100"
                      />
                      <span className="text-sm text-gray-500 dark:text-slate-400">% 时触发报警</span>
                    </div>

                    <button
                      onClick={() => {
                        const newRules = alertConfig.rules.filter((_, i) => i !== idx);
                        setAlertConfig({...alertConfig, rules: newRules});
                      }}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <Trash2 size={16}/>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'clientMedia' && (
         <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 animate-in fade-in duration-200">
           <ClientMediaManager projectId={editingId} />
         </div>
      )}

      {/* AI Expand Modal */}
      <AiExpandModal 
        isOpen={aiExpandState.isOpen}
        onClose={() => setAiExpandState({ isOpen: false, themeName: '', packageId: null, itemId: null })}
        brandName={brand.name || '当前品牌'}
        themeName={aiExpandState.themeName}
        onConfirm={handleAiExpandConfirm}
      />
    </div>
  );
}

export default SeoConfig;
console.log("cache invalidator 1");
